import { groupWebSectionsIntoRows } from "byzantine/src/dbbl/businessLogic/modules/userDisplayPreferences/utils";

import type { WebSection } from "byzantine/src/dbbl/businessLogic/modules/userDisplayPreferences";

export const getSectionKey = (items: WebSection[]): string =>
  items.map(({ section_id }) => section_id).join("-");

export const getFormattedSectionKey = (
  section: WebSection | WebSection[]
): string => {
  if (section instanceof Array) {
    return getSectionKey(section);
  }

  return section.section_id;
};

export const isSectionHalfRow = (section: WebSection[]): boolean =>
  !!section.find((item) => item.section_id === "blank");

export const withoutBlankSections = (sections: WebSection[]) =>
  sections.filter(({ section_id }) => section_id !== "blank");

export const flattenRowsForReorder = (
  rows: (WebSection | WebSection[])[]
): WebSection[] => {
  const isOddNumberOfHalfRows = rows.reduce(
    (acc, row) =>
      row instanceof Array
        ? acc || row.some(({ section_id }) => section_id === "blank")
        : acc,
    false
  );
  const lastHalfRowIndex = rows.reduce(
    (lastIndex, row, index) => (row instanceof Array ? index : lastIndex),
    -1
  );

  if (
    lastHalfRowIndex === -1 ||
    lastHalfRowIndex === rows.length - 1 ||
    !isOddNumberOfHalfRows
  ) {
    return withoutBlankSections(rows.flat());
  }

  // If we have a half row that is not the last row, we need to move it to
  // the end of the list.
  const reorderedRows = [...rows];
  const [lastHalfRow] = reorderedRows.splice(lastHalfRowIndex, 1);
  reorderedRows.push(lastHalfRow);

  return withoutBlankSections(reorderedRows.flat());
};

export const formatRowsForRender = (
  values: WebSection[],
  getRowSize: (sectionId: string) => number
): (WebSection | WebSection[])[] => {
  const blankSection: WebSection = { section_id: "blank" };

  return groupWebSectionsIntoRows(values, getRowSize).map((row) =>
    Array.isArray(row) && row.length === 1 ? [...row, blankSection] : row
  );
};
